module.exports = __webpack_public_path__ + "static/ProductdeveHover-42c687f201d641e019274f62c1f86fbb.png";